<div class="myModal" >
	<div class="modal-header">
		<button (click)="exitModal(false)" class="close" aria-label="close">
			<mat-icon aria-hidden="true">close</mat-icon>
		</button>
	</div>
	<div class="modal-body">
		<div>{{ labelsKeys.details | translate }}</div>
		<div>{{ labelsKeys.id | translate }} {{boampAvis.idWeb}}</div>
		<div>{{ labelsKeys.objet | translate }} {{boampAvis.objet}}</div>
		<div>{{ labelsKeys.famille | translate }} {{boampAvis.famille}}</div>
		<div>{{ labelsKeys.departement | translate }}
			<ul *ngFor="let item of boampAvis.departements">
				<li>  {{item}} </li>
			</ul>
		</div>

		<p class="mt-3">
			{{ labelsKeys.refConsultationInfo | translate }} <strong>{{refConsultation || 'N/A'}}</strong>
		</p>
		<p class="mt-3" style="font-style: italic;">
			{{ labelsKeys.refConsultationHelp | translate }}
		</p>
	</div>
	<div class="modal-footer">
		<button aria-label="Annuler" (click)="exitModal(false)"
			class="btn btn-outline-primary mr-auto">{{ labelsKeys.annuler | translate }}</button>
		<button aria-label="Valider" (click)="exitModal(true)"
			class="btn btn-primary ml-3">{{ labelsKeys.valider | translate }}</button>
	</div>
</div>
